<val-carte-dashboard [titre]="'dashboard.carte-suivi-regularisations-vente.titre' | transloco" [colonnes]="9" [lignes]="2"
	[chargementEnCours]="chargementEnCours" [estEnErreur]="estEnErreur">

	<ng-template>
	@if (donnees)
	{

	<div class="val-carte-suivi-regularisations-blocs">

		<!-- Bloc : Mises en attente par l'acheteur -->
		<div class="val-carte-suivi-regularisations-bloc">
			<div class="val-carte-suivi-regularisations-bloc-entete">
				<span class="val-carte-suivi-regularisations-badge">
					{{ donnees.nombreTotalMisesEnAttenteParAcheteur }}
				</span>
				<span class="val-carte-suivi-regularisations-bloc-libelle">
					{{ 'dashboard.carte-suivi-regularisations-vente.mises-en-attente.libelle' | transloco }}
				</span>
			</div>
			<div class="val-carte-suivi-regularisations-bloc-lignes">
				@if (donnees.nombreTotalMisesEnAttenteParAcheteur === 0)
				{
					<span class="val-carte-suivi-regularisations-vide">
						{{ 'dashboard.carte-suivi-regularisations-vente.mises-en-attente.aucune-donnee' | transloco }}
					</span>
				}
				@for (statut of donnees.misesEnAttenteParAcheteur; track statut.codeStatut)
				{
					@if (statut.nombre > 0)
					{
					<button type="button" class="val-carte-suivi-regularisations-ligne"
						[style.--ligne-couleur-survol]="CalculerCouleurFond(statut.couleurCode)"
						(click)="NaviguerVersFacturesVente(identifiantOngletMisesEnAttente)">
						<span class="val-carte-suivi-regularisations-statut-nombre" [style.color]="statut.couleurCode ?? 'inherit'">{{ statut.nombre }}</span>
						<span class="val-carte-suivi-regularisations-puce" [style.background-color]="statut.couleurCode ?? 'transparent'"></span>
						<span class="val-carte-suivi-regularisations-statut-libelle">{{ statut.libelle }}</span>
						<span class="val-carte-suivi-regularisations-statut-montant" [style.color]="statut.couleurCode ?? 'inherit'">
							{{ statut.montantTtc | translocoCurrency }}
						</span>
					</button>
					}
				}
			</div>
		</div>

		<!-- Séparateur vertical -->
		<div class="val-carte-suivi-regularisations-separateur"></div>

		<!-- Bloc : Statuts bloquants à traiter -->
		<div class="val-carte-suivi-regularisations-bloc">
			<div class="val-carte-suivi-regularisations-bloc-entete">
				<span class="val-carte-suivi-regularisations-badge">
					{{ donnees.nombreTotalStatutsBloquantsATraiter }}
				</span>
				<span class="val-carte-suivi-regularisations-bloc-libelle">
					{{ 'dashboard.carte-suivi-regularisations-vente.statuts-bloquants.libelle' | transloco }}
				</span>
			</div>
			<div class="val-carte-suivi-regularisations-bloc-lignes">
				@if (donnees.nombreTotalStatutsBloquantsATraiter === 0)
				{
					<span class="val-carte-suivi-regularisations-vide">
						{{ 'dashboard.carte-suivi-regularisations-vente.statuts-bloquants.aucune-donnee' | transloco }}
					</span>
				}
				@for (statut of donnees.statutsBloquantsATraiter; track statut.codeStatut)
				{
					@if (statut.nombre > 0)
					{
					<button type="button" class="val-carte-suivi-regularisations-ligne"
						[style.--ligne-couleur-survol]="CalculerCouleurFond(statut.couleurCode)"
						(click)="NaviguerVersFacturesVente(identifiantOngletEnErreur)">
						<span class="val-carte-suivi-regularisations-statut-nombre" [style.color]="statut.couleurCode ?? 'inherit'">{{ statut.nombre }}</span>
						<span class="val-carte-suivi-regularisations-puce" [style.background-color]="statut.couleurCode ?? 'transparent'"></span>
						<span class="val-carte-suivi-regularisations-statut-libelle">{{ statut.libelle }}</span>
						<span class="val-carte-suivi-regularisations-statut-montant" [style.color]="statut.couleurCode ?? 'inherit'">
							{{ statut.montantTtc | translocoCurrency }}
						</span>
					</button>
					}
				}
			</div>
		</div>

	</div>

	}
	</ng-template>

</val-carte-dashboard>
